<template>
  <div v-if="mbr.nomineeList">
    <common ref="common" />
    <ConfirmBox ref="confirmBox" @confirm="confirmed"/>
    <v-card class="rounded-xl" elevation="5">
      <v-card-title>
        <v-icon left>
          mdi-account-group
        </v-icon>
        <span>Nominee</span>
        <v-spacer></v-spacer>
        <v-btn
          v-if="mbr.nomineeList.length"
          @click="setNominee(getNewNom())"
          fab
          x-small
          elevation="0"
          dark
          color="success"
          ><v-icon dark>mdi-plus</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-simple-table :key="tblKey">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Nominee</th>
                <th>Relation</th>
                <th class="text-right">Percentage</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="mbr.nomineeList.length">
              <tr v-for="(m, mIndex) in mbr.nomineeList" :key="mIndex">
                <td>{{ m.name }}</td>
                <td>{{ m.relation }}</td>
                <td class="text-right">{{ m.settlementPercentage }}%</td>
                <td class="d-flex align-center" style="gap:10px">
                  <v-btn class="pa-3" icon x-small elevation="0" @click="deleteNomConfirm(m.id)"
                    ><v-icon class="" color="error">mdi-delete</v-icon></v-btn
                  >
                  <v-btn
                    class="pa-3"
                    icon
                    color="success"
                    x-small
                    elevation="0"
                    @click="setNominee(m)"
                    ><v-icon>mdi-pencil</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center" @click="setNominee(getNewNom())">
                  Click <v-icon color="success">mdi-plus-circle</v-icon> to add
                  nominees
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="d-flex justify-end pt-5">
          <v-btn color="primary" @click="save" small>Save</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogIsOpen">
      <NomineeDetailsForm
        v-if="dialogIsOpen"
        ref="nominee"
        :nominee="nominee"
        @nomineeChanged="nomineeChanged"
        @closeDialog="closeDialog"
      />
    </v-dialog>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
export default {
  components: {
    NomineeDetailsForm: () =>
      import(
        "@/components/wesupport/member/nomineeDetails/NomineeDetailsForm.vue"
      ),
    common: () => import("@/components/tools/common.vue"),
    ConfirmBox:()=>import("@/components/tools/toolbox/ConfirmBox.vue")
  },
  data: () => ({
    dialogIsOpen: false,
    nominee: {
      person: {},
    },
    nomToDeleteID:"",
    tblKey:0
  }),
  props: {
    mbr: Object,
  },
  mounted() {
  },
  methods: {
    openDialog() {
      this.dialogIsOpen = true;
    },
    closeDialog() {
      this.initNominee();
      this.dialogIsOpen = false;
    },
    setNominee(nom) {
      this.nominee = nom;
      this.openDialog();
    },
    getNewNom(){
      let newNom = {
          dumId:this.mbr.nomineeList.length + 1,
          person:{}
        }
        console.log("newNom",newNom);
        return newNom
    },
    initNominee(){
      this.nominee = {
        // id:this.mbr.nomineeList.length + 1,
        person:{}
      }
    },
    nomineeChanged(nom) {
      let nomIndex = this.mbr.nomineeList.findIndex((i) => i.id ?  i.id == nom.id : i.dumId == nom.dumId ); 
      if (nomIndex == -1) {
        this.mbr.nomineeList.push(nom);
      } else {
        this.mbr.nomineeList[nomIndex] = nom;
      }
      this.tblKey++;
      this.closeDialog();
      // this.save();
    },
    save() {
      this.mbr.nomineeList.map((e)=>{
        
      })
      let url = "/api/wesupport/Member/NomineeSave";
      callApi(url, "post", this.mbr)
        .then((res) => {
          this.$emit("showResponse", res);
          this.closeDialog();
        })
        .catch((err) => {
          this.$emit("showResponse", err.response,false);
        });
    },
    deleteNomConfirm(id){
      this.nomToDeleteID = id;
      this.$refs.confirmBox.open();
    },
    confirmed(isConfirm){
      if(isConfirm){
        this.deleteNominee();
      }else{
        this.nomToDeleteID = "";
      }
    },
    deleteNominee(){
      this.dpLoading = true;
      if(this.nomToDeleteID){
        this.$refs.confirmBox.close();
        this.mbr.nomineeList = this.mbr.nomineeList.filter((nm)=>nm.id != this.nomToDeleteID);
      }      
    }
  },
};
</script>
